import { MarketingEventHandler } from "./MarketingEventHandler";
import OrderMarketingEventData from '@/api/services/event-types/OrderMarketingEventData';
import ProductMarketingEventData from '@/api/services/event-types/ProductMarketingEventData';

export default class FPixelEventHandler implements MarketingEventHandler {

    handlerName(): string {
        return "fpixel";
    }

    trackEvent(eventName: string, eventData) {
        if (window['fbq']) {
            window['fbq']('track', eventName, eventData);
        }
    }

    viewCart = (): void => {
        // Custom event
    };

    viewItem = (cartData: OrderMarketingEventData): void => {
        this.trackEvent("ViewContent", {
            content_ids: cartData.items.map(item => item.item_id),
            content_type: 'product',
            contents: cartData.items.map(item => ({
                id: item.item_id,
                quantity: item.quantity,
            })),
            currency: cartData.currency
        });
    };

    viewCategory = (): void => {
        this.trackEvent("ViewContent", null);
    };

    viewPage = (): void => {
        this.trackEvent("ViewContent", null);
    };

    addToCart = (_: OrderMarketingEventData, productData: ProductMarketingEventData): void => {
        this.trackEvent(
          "AddToCart",
          {
              content_ids: [productData.item_id],
              content_type: 'product',
              contents: [
                  {
                      id: productData.item_id,
                      quantity: productData.quantity,
                  }
              ],
              currency: productData.currency
          }
        );
    };

    removeFromCart = (): void => {
        // Custom event
    };

    beginCheckout = (cartData: OrderMarketingEventData): void => {
        this.trackEvent("InitiateCheckout", {
            content_ids: cartData.items.map(item => item.item_id),
            contents: cartData.items.map(item => ({
                    id: item.item_id,
                    quantity: item.quantity
                })),
            currency: cartData.currency,
            num_items: cartData.items.map(item => item.quantity).reduce((a, b) => a + b, 0),
        });
    };

    purchase = (orderData: OrderMarketingEventData): void => {
        this.trackEvent("Purchase", {
            content_ids: orderData.items.map(item => item.item_id),
            content_type: 'product',
            contents: orderData.items.map(item => ({
                id: item.item_id,
                quantity: item.quantity
            })),
            currency: orderData.currency,
            num_items: orderData.items.map(item => item.quantity).reduce((a, b) => a + b, 0),
            value: orderData.value
        });
    };

    search = (searchTerm: string): void => {
        this.trackEvent("Search", {search_string: searchTerm});
    };

    signUp = (): void => {
        this.trackEvent("CompleteRegistration", null);
    };

    login = (): void => {
        // Custom event
    };

    updateProfile = (): void => {
        // Custom event
    }
}
